<template>
  <div
    v-if="instance"
    class="private-fund-flows-form"
  >
    <div class="private-fund-flows-form__input">
      <component
        :is="instance.getFormDate()"
        :instance
        :size
        tabindex="0"
      />
    </div>
    <div class="private-fund-flows-form__input">
      <component
        :is="instance.getFormType()"
        placeholder="Select type"
        :instance
        :restrictions
        :size
        tabindex="1"
      />
    </div>
    <div class="private-fund-flows-form__input">
      <component
        :is="instance.getFormAmount2()"
        v-if="type"
        :placeholder="`Amount in ${currency}`"
        :instance
        :size
        focus-on-load
        tabindex="2"
        prefix=""
        @click:enter="handleSubmit"
      />
      <UIInputText
        v-else
        :placeholder="`Amount in ${currency}`"
        :size
        disabled
      />
    </div>
    <UIButton
      label="Add"
      :disabled="isButtonDisabled"
      :size
      :leading="PlusIcon"
      variant="secondary"
      tabindex="3"
      class="private-fund-flows-form__button"
      @click="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef, inject, onMounted, ref } from 'vue'

import { ButtonSize, Transaction, TransactionClass } from '@types'

import { TRANSACTION_FIELD } from '@/const'

import { UIButton } from '@ui/buttons'
import { UIInputText } from '@ui/fields'
import { PlusIcon } from '@heroicons/vue/24/outline'

type Props = {
  defaultData: Transaction
  restrictions: string[]
}

type Emits = {
  submit: [data: TransactionClass]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const size = inject<ButtonSize>('size')
const currency = inject<ComputedRef<string>>('currency')

const instance = ref<TransactionClass>()

const isButtonDisabled = computed(() => !type.value || !amount.value)

const type = computed(() => instance.value?.field(TRANSACTION_FIELD.TYPE).value)
const amount = computed(() => instance.value?.entry2().value?.amount)

const handleSubmit = () => {
  if (!instance.value) return
  emit('submit', instance.value)
}

onMounted(() => {
  instance.value = new TransactionClass(props.defaultData, false, false)
})
</script>

<style scoped>
.private-fund-flows-form {
  @apply grid grid-cols-1 sm:grid-cols-[.99fr_1.3fr_.85fr];
  @apply gap-2 sm:gap-3;

  &__button {
    @apply sm:col-span-3;
  }
}
</style>
